import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * # HypotensionInputData
 * 
 * HypotensionInputData을 설명하세요.
 */
export const HypotensionInputData = types
  .model('HypotensionInputData')
  // --------------------------------------------------------------------------
  .props({
    gender: types.optional(types.number, 0), //  남(0) / 여(1)
    anchor_age: types.optional(types.number, 0), // 나이
    height_cm: types.optional(types.number, 0), // 키
    weight_kg: types.optional(types.number, 0), // 몸무게
    vaso: types.optional(types.number, 0), // 혈압상승제 투여유무 (0/1)
    seda: types.optional(types.number, 0), //  진정제 투여유무 (0/1)
    trans: types.optional(types.number, 0), //  수혈 유무 (0/1)
    bolus: types.optional(types.number, 0), //  수액 투여유무 (0/1)
    windowID: types.optional(types.number, 0), //  Window ID
    starttime: types.optional(types.string, ''), //  측정 시작 시간
    endtime: types.optional(types.string, ''), //  측정 종료 시간
    HR_var: types.optional(types.number, 0), //  심장 박동수 분산 값
    HR_q1: types.optional(types.number, 0), //  심장 박동수 1사분위 값
    HR_q3: types.optional(types.number, 0), //  심장 박동수 3사분위 값
    HR_mean: types.optional(types.number, 0), //  심장 박동수 평균 값
    HR_median: types.optional(types.number, 0), //  심장 박동수 중앙 값
    HR_min: types.optional(types.number, 0), //  심장 박동수 최소 값
    HR_max: types.optional(types.number, 0), //  심장 박동수 최대 값
    SP_var: types.optional(types.number, 0), //  수축기 혈압 분산 값
    SP_q1: types.optional(types.number, 0), //  수축기 혈압 1사분위 값
    SP_q3: types.optional(types.number, 0), //  수축기 혈압 3사분위 값
    SP_mean: types.optional(types.number, 0), //  수축기 혈압 평균 값
    SP_median: types.optional(types.number, 0), //  수축기 혈압 중앙 값
    SP_min: types.optional(types.number, 0), //  수축기 혈압 최소 값
    SP_max: types.optional(types.number, 0), //  수축기 혈압 최대 값
    DP_var: types.optional(types.number, 0), //  이완기 혈압 분산 값
    DP_q1: types.optional(types.number, 0), //  이완기 혈압 1사분위 값
    DP_q3: types.optional(types.number, 0), //  이완기 혈압 3사분위 값
    DP_mean: types.optional(types.number, 0), //  이완기 혈압 평균 값
    DP_median: types.optional(types.number, 0), //  이완기 혈압 중앙 값
    DP_min: types.optional(types.number, 0), //  이완기 혈압 최소 값
    DP_max: types.optional(types.number, 0), //  이완기 혈압 최대 값
    RR_var: types.optional(types.number, 0), //  호흡 수 분산 값
    RR_q1: types.optional(types.number, 0), //  호흡 수 1사분위 값
    RR_q3: types.optional(types.number, 0), //  호흡 수 3사분위 값
    RR_mean: types.optional(types.number, 0), //  호흡 수 평균 값
    RR_median: types.optional(types.number, 0), //  호흡 수 중앙 값
    RR_min: types.optional(types.number, 0), //  호흡 수 최소 값
    RR_max: types.optional(types.number, 0), //  호흡 수 최대 값
    SPO2_var: types.optional(types.number, 0), //  산소포화도 분산 값
    SPO2_q1: types.optional(types.number, 0), //  산소포화도 1사분위 값
    SPO2_q3: types.optional(types.number, 0), //  산소포화도 3사분위 값
    SPO2_mean: types.optional(types.number, 0), //  산소포화도 평균 값
    SPO2_median: types.optional(types.number, 0), //  산소포화도 중앙 값
    SPO2_min: types.optional(types.number, 0), //  산소포화도 최소 값
    SPO2_max: types.optional(types.number, 0), //  산소포화도 최대 값
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model hypotensionInputData --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IHypotensionInputData;
      (Object.keys(newProps) as THypotensionInputDataKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type THypotensionInputData = Instance<typeof HypotensionInputData>;
type THypotensionInputDataSnapshot = SnapshotOut<typeof HypotensionInputData>

export interface IHypotensionInputData extends THypotensionInputData {}
export type THypotensionInputDataKeys = keyof THypotensionInputDataSnapshot & string;
export interface IHypotensionInputDataSnapshot extends THypotensionInputDataSnapshot {}
export const createHypotensionInputData = () => 
  types.optional(HypotensionInputData, {} as THypotensionInputData);